// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__rAtaD","header":"ClearentDisclaimer_header__cRDZE","inner":"ClearentDisclaimer_inner__2vvAA"};